import { FC, useCallback, useState } from 'react';

import { usePageTitle } from 'hooks/usePageTitle';

import { ThirdStory } from './components/ThirdStory';

type Props = {
  onNextPhase?: () => void;
};

export const Story: FC<Props> = ({ onNextPhase }) => {
  usePageTitle(`ストーリー`);
  const [step, setStep] = useState(1);

  const handleNextStep = useCallback(() => {
    setStep(prev => prev + 1);
  }, []);

  const handlePrevStep = useCallback(() => {
    setStep(prev => prev - 1);
  }, []);

  const getMaxStep = useCallback(() => {
    return 4;
  }, []);

  const handleSkipDialogue = useCallback(() => {
    const maxStep = getMaxStep();
    setStep(maxStep);

    if (onNextPhase) {
      onNextPhase();
    }
  }, [onNextPhase, getMaxStep]);

  return (
    <ThirdStory
      step={step}
      handleNextStep={handleNextStep}
      handlePrevStep={handlePrevStep}
      handleSkipDialogue={handleSkipDialogue}
    />
  );
};
